import type { I18n } from '@govard/i18n-core';

type Translator = I18n['t'];

const TOOL_KEYS: Record<string, string> = {
  get_deal_summary: 'deal_summary',
  analyze_deal_risk: 'deal_risk',
  prepare_deal_call: 'deal_call',
  get_deal_cockpit: 'deal_cockpit',
  plan_deal_actions: 'deal_plan',
  add_deal_note: 'add_note',
  draft_email: 'draft_email',
  send_email: 'send_email',
  update_deal_stage: 'update_stage',
  create_deal_tasks: 'create_tasks',
  get_contact_history: 'contact_history',
  get_manager_briefing: 'manager_briefing',
  show_hot_leads: 'hot_leads',
  run_scenario: 'run_scenario',
  list_recent_activities: 'recent_activities',
  search_deals: 'search_deals',
  show_view: 'show_view',
  search_contacts: 'search_contacts',
  list_recent_memories: 'recent_memories',
  write_memory: 'write_memory',
  update_memory: 'update_memory',
  delete_memory: 'delete_memory',
  list_view_catalog: 'view_catalog',
  find_records: 'find_records',
  build_view: 'build_view',
  save_view: 'save_view',
  get_deal: 'deal_summary',
  get_contact: 'contact_history',
  read_task: 'read_task',
  create_task: 'create_task',
  update_task: 'update_task',
  delete_task: 'delete_task',
  set_task_status: 'set_task_status',
  assign_task: 'assign_task',
  link_task: 'link_task',
  unlink_task: 'unlink_task',
  set_task_due_date: 'set_task_due_date',
  read_note: 'read_note',
  create_note: 'create_note',
  update_note: 'update_note',
  delete_note: 'delete_note',
  link_note: 'link_note',
  unlink_note: 'unlink_note',
  search_tasks: 'search_tasks',
  bulk_read_contacts: 'bulk_read_contacts',
  bulk_read_companies: 'bulk_read_companies',
  bulk_read_notes: 'bulk_read_notes',
  bulk_read_documents: 'bulk_read_documents',
  bulk_read_templates: 'bulk_read_templates',
  bulk_read_attachments: 'bulk_read_attachments',
  bulk_read_contact_interactions: 'bulk_read_contact_interactions',
  bulk_read_calendar_events: 'bulk_read_calendar_events',
  read_company: 'read_company',
  read_company_revenue: 'read_company_revenue',
  read_document: 'read_document',
  read_attachment: 'read_attachment',
  read_attachment_content: 'read_attachment_content',
  read_attachment_image: 'read_attachment_image',
  read_template: 'read_template',
  read_calendar_event: 'read_calendar_event',
  read_calendar_events: 'read_calendar_events',
  list_attachments: 'list_attachments',
  list_imports: 'list_imports',
  preview_import: 'preview_import',
  execute_import: 'execute_import',
  investigate_crm_context: 'investigate_crm_context',
  analyze_meeting_note: 'analyze_meeting_note',
  conversation_to_note: 'conversation_to_note',
  document_to_note: 'document_to_note',
  create_deal: 'create_deal',
  update_deal: 'update_deal',
  delete_deal: 'delete_deal',
  bulk_create_templates: 'bulk_create_templates',
  bulk_update_templates: 'bulk_update_templates',
  enrich_contact: 'enrich_contact',
  get_sales_health: 'get_sales_health',
  propose_touch_strategy: 'touch_strategy',
  extract_deal_qualification: 'deal_qualification',
  update_deal_qualification: 'update_deal_qualification',
  generate_dashboard_widget: 'generate_dashboard_widget',
  refresh_entity_context: 'refresh_entity_context',
  propose_candidate_refinement: 'propose_candidate_refinement',
  delegate_deal_specialist: 'delegate_deal_specialist',
  delegate_tasks_specialist: 'delegate_tasks_specialist',
  propose_crm_action_plan: 'action_plan_draft',
  create_crm_action_plan: 'action_plan_start',
  crm_list_v1: 'crm_list',
  web_fetch: 'web_fetch',
  web_search: 'web_search',
  deep_research: 'deep_research',
  search_projects: 'search_projects',
  read_project: 'read_project',
  create_project: 'create_project',
  update_project: 'update_project',
};

export function localizedToolName(name: string, t: Translator): string {
  const key = TOOL_KEYS[name];
  if (key) {
    const translated = t(`crm.ai_ui.tool.${key}.name`);
    if (translated && !translated.startsWith('crm.ai_ui.tool.')) {
      return translated;
    }
  }
  return name;
}

export function localizedCapabilityDescription(
  name: string,
  fallback: string,
  t: Translator,
): string {
  const key = TOOL_KEYS[name];
  if (key) {
    const translated = t(`crm.ai_ui.tool.${key}.description`);
    if (translated && !translated.startsWith('crm.ai_ui.tool.')) {
      return translated;
    }
  }
  return fallback;
}
